import { useFeatureValue } from "@growthbook/growthbook-react";

export function useFeatureFlag(id: string, fallback: any) {
  const value = useFeatureValue(id, fallback);
  return value;
}
